export default function totalStudentThresholdCount (data) {
  let total = 0
  data.forEach((range) => {
    total += range.count
  })
  return total
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/totalStudentThresholdCount.js